import React, { useState } from "react";
import BackButton from "../../shared/BackButton";
import { getPrevPageUrl, getVehiclePath } from "../../Utils/Common";
import { setMilitaryInfo } from "../../Utils/Common";
import { NavLink } from "react-router-dom";

function Military(props) {
  const [option, setOption] = useState("");

  const handleClick = (e) => {
    setOption(e);
    if (e === "no") {
      setMilitaryInfo(null);
    }
  };

  const nextPath = getVehiclePath();

  return (
    <div className="wrapper wrapper-flex">
      <div className="container">
        <div className="row mt-5">
          <div className="col-sm-12 col-md-8 mx-auto">
            <h1 className="font-weight-bold text-center mb-4">Your Reservation Indicates Active Military. Is That Accurate?</h1>
            <div className="form-group mt-5">
              <button
                onClick={(e) => handleClick("yes")}
                className={option === "yes" ? "btn btn-lg btn-block btn-secondary" : "btn btn-lg btn-block btn-pink"}
              >
                Yes
              </button>
            </div>
            <div className="form-group mt-5">
              <button
                onClick={(e) => handleClick("no")}
                className={option === "no" ? "btn btn-lg btn-block btn-secondary" : "btn btn-lg btn-block btn-pink"}
              >
                No
              </button>
            </div>
            <div className="row mt-4">
              {(option === "yes" || option === "no") && (
                <div className="col-12 text-right">
                  <NavLink
                    to={{
                      pathname: option === "yes" ? "/military-details" : nextPath,
                      state: {
                        prevPageUrl: "/military",
                      },
                    }}
                    className="btn btn-pink btn-lg letter-spacing-2"
                  >
                    Next
                  </NavLink>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <BackButton backPath={getPrevPageUrl("military", props)} />
    </div>
  );
}

export default Military;
